import { variant1 } from './contstants';
const useConfiguration = (variant) => {
    let isUnderlinedReadMore = false;
    switch (variant) {
        case variant1:
            isUnderlinedReadMore = true;
            break;
        default:
            break;
    }
    return {
        isUnderlinedReadMore,
    };
};
export default useConfiguration;
